<template>

    <!--show 远离底部-->
    <div :class="$mapStep.type=='selectePOI' && $mapStep.poiID  ? 'brt-map-locateModule show':'brt-map-locateModule'" ref="locateModule">

        <!--正常状态--> <!--定位成功--><!--切转方向标--><!--没提示-->
        <div class="box" v-if="$store.state.mapStore.isShow(moduleState,[0,1,2,3])" :state ="moduleState" @click.stop="success">

            <div :class="moduleState == 3?'txt':'txt show'">
                <span v-if="moduleState == 0">可切转地图视角</span>
                <span v-if="moduleState == 1">定位成功</span>
                <span v-if="moduleState == 2">已切转方向标视角</span>
            </div>

            <div class="circle" :style="{transform: 'rotate('+ $BRT.$NAVTO.angle +'deg)'}">
                <i class="iconfont icon-locate-normal"></i>
            </div>

        </div>


        <!--未开蓝牙--><!--扫不到设备--><!--无按钮--><!--没提示-->
        <div class="box" v-if="$store.state.mapStore.isShow(moduleState,[4,5,6,7])" :state ="moduleState">

            <div :class="moduleState == 7?'txt':'txt show'">

                <span v-if="moduleState !=4 && moduleState != 7">无定位设备</span>
                <span v-if="moduleState == 4">{{openDeviceTip}}</span>

                <Button size="small" type="block" v-if="moduleState == 5">暂不定位</Button>
                <Button size="small" v-if="moduleState != 6 && moduleState != 7" @click.native.stop="openLocation">再搜一次</Button>

            </div>

            <div class="circle" @click="openLocation">
                <i class="iconfont icon-wudingwei"></i>
            </div>

        </div>

        <!--切换视角--><!--没提示-->
        <div class="box" v-if="$store.state.mapStore.isShow(moduleState,[8,9])" :state ="moduleState" @click.stop="viewChange">

            <div :class="moduleState == 9?'txt':'txt show'">
                <span>已切转地图视角</span>
            </div>

            <div class="circle">
                <i class="iconfont icon-daohang"></i>
            </div>
        </div>

        <!--定位信号弱--><!--没提示-->
        <div class="box" v-if="$store.state.mapStore.isShow(moduleState,[10,11])" :state ="moduleState" @click.stop="success">

            <div :class="moduleState == 11?'txt':'txt show'"><span>定位信号弱</span></div>

            <div class="circle">
                <i class="iconfont icon-rssi"></i>
            </div>

        </div>

        <!--正在定位状态-->
        <div class="box" v-if="$store.state.mapStore.isShow(moduleState,[12])" :state ="moduleState">

            <div class="txt show">
                <span>定位中&nbsp;{{locateTime}}</span>
            </div>

            <div class="circle">
                <i class="iconfont icon-loading"></i>
            </div>
        </div>

        <div class="text" v-show="test || navTest ">
            <div class="wrap">
                <div v-html="test"></div>

                <div class="btn-box">
                    <span @click.stop="test=''">清空</span>
                    <span @click.stop="test='',navTest=false">退出</span>
                </div>

            </div>
        </div>

    </div>



</template>

<script>
    import Button from "../../../../../components/button/Button.vue"
    import {getPoiInfo} from "./../../brtmap/Brtmap"

    import {get_wx_sign,stopSearchBeacons,startSearchBeacons,startonSearchBeacons} from './LocateModule.js'


    export default {
        name: "LocationModule",

        data(){
            return {
                moduleState:7,
                locateTime:10,   //加载剩余时间
                loading:true,    //加载中
                angle:0,        //定位偏转角度

                openDeviceTip:'',       //开启设备提示
                selectPoint:false,       //定位选点

                rssi:0,      //信号变化

                test:null,

                time:'',         //自动扫描

                searchAgain:false,  //再次扫描

                navTest:false,         //导航调试
            }
        },


        created(){



            //视角切换方法
            this.bus.$off('locationView');
            this.bus.$on('locationView',(boolean)=>{

                let $navigation = JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.navigation),
                    $start = this.$BRT.$selecte.startPoint,
                    $end = this.$BRT.$selecte.endPoint,
                    $map = $VAR.map,
                    $point = this.$BRT.$locate.point,
                    $navZoom = $navigation.defaultRank ? $navigation.defaultRank : 19;

                //规划路径禁用跟随模式
                if(this.$mapStep.type == 'planRoute' && boolean)return false;

                // $VAR.map.setMaxBounds($VAR.map.currentMapInfo.getBounds(0.2));//恢复地图范围

                //开启无操作自动切换楼层
                this.$BRT.$locate.allowFloor = true;

                if(boolean){

                    //定位成功处理
                    this.moduleState = 8;

                    this.$BRT.$marker.navLocation.isFirst = true;
                    this.$BRT.$marker.location.isFirst = true;

                    let $pitch = $navigation.mapAngle >=0 ? $navigation.mapAngle : 30;

                    $VAR.map.setPitch($pitch);

                    $VAR.map.setZoom($navZoom);

                    if(this.$BRT.$mapStep.type == 'toNAVING'){

                        $VAR.$nav.followBearing = true;
                        if(this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE'){

                            if(boolean == 'init'){

                                let lngLat = $start.x ?  $VAR.map.coordsToLnglat($start.x,$start.y) : $VAR.map.coordsToLnglat($start.LABEL_X,$start.LABEL_Y);

                                if($start.x){
                                    if($VAR.map.currentMapInfo.floorNumber != $start.floor){

                                        let $zoom = $VAR.map.getZoom(),
                                            $floorId = $VAR.map.getFloorInfoByIndex($start.floor).floorID;

                                        $VAR.map.setFloor($floorId,()=>{
                                            $VAR.map.stop().easeTo({
                                                zoom:$zoom
                                            })
                                        });
                                    }
                                }

                                $VAR.map.setCenter(lngLat);
                            }

                            // this.$BRT.$NAVTO.$NAVSIMULATE.enableFollow();

                        }else{

                            if(this.$BRT.$NAVTO.NAVType == 'NAVINDICATE'){

                                if(boolean == 'init'){    //起点为中心

                                    let lngLat = lngLat = $start.x ?  $VAR.map.coordsToLnglat($start.x,$start.y) : $VAR.map.coordsToLnglat($start.LABEL_X,$start.LABEL_Y);
                                    //楼层问题(可见数据)
                                    if($start.x){
                                        if($VAR.map.currentMapInfo.floorNumber != $start.floor){

                                            let $zoom = $VAR.map.getZoom(),
                                                $floorId = $VAR.map.getFloorInfoByIndex($start.floor).floorID;
                                            $VAR.map.setFloor($floorId,()=>{
                                                $VAR.map.stop().easeTo({
                                                    zoom:$zoom
                                                })
                                            });
                                        }
                                    }

                                    $VAR.map.setCenter(lngLat);

                                }else{

                                    if($point){    //定位点为中心
                                        $VAR.map.setCenter({lng:$point.lng,lat:$point.lat})
                                    }
                                }
                            }
                        }


                    }else{


                        if($point){

                            //切换楼层
                            if($VAR.map.currentMapInfo.floorNumber != $point.floor){

                                let $zoom = $VAR.map.getZoom(),
                                    $floorId = $VAR.map.getFloorInfoByIndex($point.floor).floorID;

                                $VAR.map.setFloor($floorId,()=>{
                                    $VAR.map.stop().easeTo({
                                        zoom:$zoom
                                    })
                                });

                            }

                            //切换到当前定位位置
                            $VAR.map.setCenter({lng:$point.lng,lat:$point.lat})

                            // $VAR.map.easeTo({
                            //     center: {lng:this.$BRT.$locate.point.lng,lat:this.$BRT.$locate.point.lat}
                            // })

                        }
                    }


                }

                else{

                    //切换视角(关闭视角)
                    this.moduleState = 2;

                    this.$BRT.$marker.navLocation.isFirst = false;
                    this.$BRT.$marker.location.isFirst = false;


                    // $VAR.map.easeTo({
                    //     pitch:0,
                    //     bearing:this.$BRT.$NAVTO.initAngle,
                    // })

                    //设置地图相关
                    $VAR.map.setPitch(0);
                    $VAR.map.setBearing(this.$BRT.$NAVTO.initAngle);
                    // $VAR.map.setZoom($VAR.map.getBaseZoom());

                    if(this.$BRT.$mapStep.type == 'toNAVING'){

                        $VAR.$nav.followBearing = false;
                        let $navZoom = $navigation.defaultRank >= 0 ? $navigation.defaultRank :19;

                        if(this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE'){ //模拟导航处理

                            $VAR.map.setZoom($navZoom);
                            // this.$BRT.$NAVTO.$NAVSIMULATE.disableFollow();

                        }else if(this.$BRT.$NAVTO.NAVType == 'NAVINDICATE'){

                            $VAR.map.setZoom($navZoom);

                            if($point){
                                //中心
                                $VAR.map.setCenter({lng:$point.lng,lat:$point.lat});

                                //切回状态
                                if($point.rssi == 0){
                                    this.moduleState = 7
                                }else if($point.rssi == 1){
                                    this.moduleState = 11
                                }
                            }
                        }

                    }else{

                        if(this.$BRT.$mapStep.type !='planRoute'){

                            if($point){

                                //切换楼层
                                if($VAR.map.currentMapInfo.floorNumber != $point.floor){

                                    let $zoom = $VAR.map.getZoom(),
                                        $floorId = $VAR.map.getFloorInfoByIndex($point.floor).floorID;

                                    $VAR.map.setFloor($floorId,()=>{
                                        $VAR.map.stop().easeTo({
                                            zoom:$zoom
                                        })
                                    });

                                }

                                //切换到当前定位位置
                                // $VAR.map.easeTo({
                                //     center: {lng:$point.lng,lat:$point.lat}
                                // })

                                //中心
                                $VAR.map.setCenter({lng:$point.lng,lat:$point.lat})

                            }

                        }

                        //无定位
                        if(!$point){
                            this.moduleState = 7;
                        }

                    }

                }


                /*****防止懒加载或定位点延迟定位图标显示不正常*****/
                let $locateMaker = this.$BRT.$marker.location,
                    $makerShow =$locateMaker.marker._lnglat[0] === 0 && $locateMaker.marker._lnglat[1] === 0;
                if(!$makerShow && ["planRoute","toNAVING"].indexOf(this.$mapStep.type) === -1){
                    $locateMaker.setLnglat($point,$point.floor,false);
                }

            })

            //关闭定位
            this.bus.$off('locateFailClose')

            this.bus.$on('locateFailClose',()=>{this.selectPoint = false})

            //开启定位
            this.bus.$off('openLocation');
            this.bus.$on('openLocation',()=>{

                if(this.moduleState != 12){
                    this.moduleState = 12;
                }

                // else{
                //     this.$message.info('正在定位中,请稍等')
                // }
            })

            //导航调试
            this.bus.$off('navAndLocationTest');
            this.bus.$on('navAndLocationTest',(res)=>{

                this.navTest = res.status;

                if(res.data){
                    this.test += `<p>point y:${res.data.y}</p>`;
                    this.test += `<p>point x:${res.data.x}</p>`
                    this.test += `<p>point lat:${res.data.lat}</p>`
                    this.test += `<p>point lng:${res.data.lng}</p>`
                    this.test += `<p>我是偏转计算距离distant:${res.data.devDistance}</p>`
                    this.test += `<p>我是偏转距离:${res.data.distant}</p>`
                    this.test += `<p>我是吸附点:${res.data.nearPoint}</p>`
                }

                if(res.result){
                    this.test += `<p>我是定位回传点:${res.result.x}</p><p>我是信号值:${res.result.rssi}</p><p>我是角度:${res.result.angle}</p><p>我是经纬度:${res.result.lng}</p><p>我是经纬度:${res.result.lat}</p>`;
                }

                if(res.toptest){
                    this.test += `<p>顶部测试:${res.toptest}</p>`;
                }


                if(res.test1){
                    this.test += `<p>导航测试:${res.test1}</p>`;
                }

                if(res.test2){
                    this.test += `<p>导航测试:${res.test2}</p>`;
                }
                if(res.test3){
                    this.test += `<p>导航测试:${res.test3}</p>`;
                }
                if(res.test4){
                    this.test += `<p>导航测试:${res.test4}</p>`;
                }

                if(res.test5){
                    this.test += `<p>导航测试:${res.test5}</p>`;
                }

                if(res.test6){
                    this.test += `<p>导航测试:${res.test6}</p>`;
                }

                if(res.test7){
                    this.test += `<p>导航测试:${res.test7}</p>`;
                }

                if(res.test8){
                    this.test += `<p>导航测试:${res.test8}</p>`;
                }

                if(res.test9){
                    this.test += `<p>导航测试:${res.test9}</p>`;
                }
            })

        },

        methods:{

            //获取签名
            get_wx_sign(){

                let $this=this;

                get_wx_sign($this.$store.state.mapStore,$this.wx,function () {

                    $this.startLocate();
                    $this.onSearchBeacons();

                    let $plug = $this.$mapStore.plugInfo.plugInfo,
                        $sign = sessionStorage.getItem('sign'),
                        $link = $sign? window.location.href.split('?')[0] + '?sign='+$sign : window.location.href.split('?')[0],
                        $share = {
                            title:$plug.name,
                            desc:'好友分享了此场景室内地图应用，一键导航、寻店、寻人等，点击查看',
                            imgUrl:$plug.plugInSettings.shareIcon,
                            link:$link
                        },

                        shareCallback = (res)=>{


                            //设置分享信息 （分享标识[可不传，但是必须要接收并且分享时，需要将这个ID写入链接中；用户点击进来的时候，再来源那里设置该ID和类型]，分享业务类型[1：主题活动；2：店铺活动；3：其他页面；4：POI；5：其他], 分享业务ID[主题活动页面ID/店铺活动页面ID/其他页面ID/POIID]）
                            if(res.poiId){
                                //分享
                                $this.$userUpdata.setShare('',4,res.poiId);

                            }else{
                                //其他
                                $this.$userUpdata.setShare('',5,'');
                            }



                            // 分享到朋友圈
                            $this.wx.onMenuShareTimeline({
                                title:res.title, // 分享标题
                                link: res.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: res.imgUrl, // 分享图标
                                success: function () {
                                    // 用户确认分享后执行的回调函数
                                },
                                cancel: function () {
                                    // 用户取消分享后执行的回调函数
                                }
                            });

                            // 分享给朋友
                            $this.wx.onMenuShareAppMessage({
                                title: res.title, // 分享标题
                                desc: res.desc, // 分享描述
                                link: res.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: res.imgUrl, // 分享图标
                                success: function () {
                                },
                                cancel: function () {
                                    // 用户取消分享后执行的回调函数
                                }
                            });

                        };

                    shareCallback && shareCallback($share);

                    //分享设置
                    $this.bus.$off('share_config');
                    $this.bus.$on('share_config',(res)=>{
                        shareCallback && shareCallback(res);
                    })

                })

            },

            //开始扫描
            startLocate(){
                let $this =this;
                if($this.$BlueState === -2){
                    $this.openDeviceTip = '请打开GPS再定位';
                    $this.moduleState=4;
                    $this.loading = false;  //关闭加载及定时器
                }
                else if($this.$BlueState === -1){
                    $this.openDeviceTip = '请打开蓝牙再定位';
                    $this.moduleState=4;
                    $this.loading = false;  //关闭加载及定时器
                }

            },

            //监听设备
            onSearchBeacons(){

                /**
                 * ios耗电情况说明
                 * 1.startonSearchBeacons回调函数被多次执行导致执行多次StartPositioning
                 * 2.插标问题导致（不插标耗电量明显降低）
                 * 3.ios扫描处理过快
                 * **/

                //定位点
                let $this=this,

                    $brtmap=$this.$BRT,

                    locateFloor,                    //定位点楼层信息

                    firstLocationFloor,             //记录楼层

                    $currentFloor,                  //当前楼层信息

                    $locatePoint = {},              //记录点位
                    $checkPoint = false,            //排查点位问题
                    $locateLazy = false,            //定位点漫游懒加载
                    $locateTransit = false,         //定位点过渡动画
                    $locateIsRoutePoint = false,    //采用路网点替换定位点
                    isChangeFlooring = false,       //提升切换楼层体验
                    updataLocate = 0,               //一秒上报一次

                    $locateInertance = $brtmapLocate.inertance,  //定位惯性

                    $urlparamEvents = ()=>{

                        /*****链接操作******/

                         //筛选数据
                        let $urlParam = $brtmap.$urlParam;
                        //筛选查找
                        if($urlParam.filter.status){$this.bus.$emit('getFilter_bus',$locatePoint)}
                        //附近电梯
                        else if($urlParam.nearLift.status){$this.bus.$emit('getNearLift',$locatePoint)}
                        //规划路径获取起点
                        else if($urlParam.planRoute.status && $urlParam.planRoute.endPoi){$this.bus.$emit('getPlanRoute_start',$locatePoint)}

                        /*****链接操作******/

                    },

                    $floorEvents = (callback)=>{
                        //公用切换楼层方法
                        if(locateFloor){
                            isChangeFlooring = true;
                            let $zoom = $VAR.map.getZoom();
                            $VAR.map.setFloor(locateFloor.floorID,()=>{

                                $this.bus.$emit('changeFloorInfo',$locatePoint);

                                //设置中心点
                                $VAR.map.stop().easeTo({
                                    center: [$locatePoint.lng,$locatePoint.lat],
                                    zoom:$zoom,
                                    duration:300
                                });


                                setTimeout(()=>{isChangeFlooring = false},500);

                                /*****防止懒加载或定位点延迟定位图标显示不正常*****/
                                let $locateMaker = $brtmap.$marker.location,
                                    $makerShow =$locateMaker.marker._lnglat[0] === 0 && $locateMaker.marker._lnglat[1] === 0;
                                if(!$makerShow){
                                    $locateMaker.setLnglat($locatePoint,$locatePoint.floor,$locateTransit);
                                }

                                callback && callback();
                            })

                        }

                    };


                //开启微信监听
                this.wx.onSearchBeacons({

                    complete:(argv)=> {
                        //关闭扫描问题
                        $this.searchAgain = false;
                        $brtmapLocate.StartPositioning(argv);
                    }
                });

                //监听点位
                $brtmapLocate.on('location',point=>{


                    //每隔1s上传一次定位点
                    if(firstLocationFloor && point){

                        if(+new Date() - updataLocate > 1000){

                            updataLocate = +new Date();

                            //获取poid点位信息
                            let poiId='',
                                poi = getPoiInfo($brtmap,$VAR.map.project(point),1200);

                            if(poi && poi.POI_ID)poiId = poi.POI_ID;

                            $this.$userUpdata.setLocation(point.x,point.y,point.floor,poiId);

                        }
                    }


                    //检查
                    if($checkPoint && point){$brtmap.$marker.point.setLnglat(point)}

                    //搜索、分享、模拟导航、非地图页面不执行
                    if( $this.searchAgain ||
                        $brtmap.$urlParam.share.status ||
                        $brtmap.$NAVTO.NAVType == 'NAVSIMULATE' ||
                        !$brtmap.$locate.init && !$this.$route.path.match('/map')
                    ){
                        $brtmap.$marker.location.empty();
                        return false
                    }

                    //切换楼层防止干扰
                    if(isChangeFlooring)return false;

                    //定位成功
                    $this.$BlueState = 2;

                    if(point){

                        //清除计时器
                        $this.loading = '';

                        //点位记录
                        $locatePoint = Object.assign({},$locatePoint,point);

                        //记录定位点楼层信息
                        if(!locateFloor || locateFloor.floorNumber != point.floor){
                            locateFloor = $VAR.map.getFloorInfoByIndex(point.floor);
                        }

                        //记录当前楼层信息
                        if(!$currentFloor || $currentFloor.floorNumber != $VAR.map.currentMapInfo.floorNumber){
                            $currentFloor = $VAR.map.currentMapInfo;
                        }


                        //初次定位成功
                        if(!firstLocationFloor){

                            //上报定位成功，上报一次
                            $this.$userUpdata.setLocationSuccess();

                            //防止干扰
                            if($brtmap.$locate.init || $brtmap.$locate.islocate){
                                $brtmap.$locate.init = false;
                                $brtmap.$locate.islocate = false;
                            }

                            //楼层问题
                            if(!$this.$mapStep.type){

                                if($currentFloor.floorNumber != point.floor){
                                    $floorEvents(()=>{

                                        if($brtmap.$marker.location){
                                            $brtmap.$marker.location.setLnglat(point,point.floor,$locateTransit);
                                        }

                                    });
                                }
                                else{

                                    if($brtmap.$marker.location){
                                        $brtmap.$marker.location.setLnglat(point,point.floor,$locateTransit);
                                    }


                                    let $zoom = $VAR.map.getZoom();
                                    $VAR.map.stop().easeTo({
                                        center: [point.lng,point.lat],
                                        zoom:$zoom,
                                        duration:300
                                    });

                                }
                            }


                            //链接操作
                            $urlparamEvents && $urlparamEvents();

                            //视角处理
                            if($this.$mapStep.type != 'toNAVING'){

                                if($brtmap.$marker.location.isFirst)return false;

                                if ($this.moduleState != 8 && $this.moduleState != 9) { //定位成功

                                    $this.moduleState = 1;
                                    $this.$BRT.$marker.location.isFirst = false;

                                } else {

                                    $this.$BRT.$marker.location.isFirst = true;
                                }

                            }

                            else{

                                if($this.$BRT.$marker.location.isFirst){
                                    $this.moduleState = 9;
                                }

                            }

                            if(!firstLocationFloor){firstLocationFloor = point.floor}

                        }

                        else{

                            if(firstLocationFloor != point.floor){

                                if(
                                    $this.$mapStep.type == 'toNAVING' ||
                                    (!$this.$mapStep.type && $brtmap.$marker.location.isFirst)
                                ){

                                    firstLocationFloor = point.floor;

                                    //切换楼层
                                    $floorEvents();
                                }

                            }


                            //普通定位点切换楼层
                            if( !$this.$mapStep.type &&
                                $brtmap.$locate.allowFloor &&
                                point.floor != $currentFloor.floorNumber
                            ){

                                $brtmap.$locate.allowFloor = false;
                                $floorEvents(()=>{
                                    $brtmap.$locate.allowFloor = true;
                                });
                            }

                            //导航 ||定位图标渲染
                            if($this.$mapStep.type == 'toNAVING'){

                                $brtmap.$marker.location.empty();
                                $brtmap.$marker.virtualLocation.empty();

                                //关闭定位惯性(防止影响导航)
                                if($locateInertance){
                                    if($brtmapLocate.inertance) $brtmapLocate.inertance = false;
                                }


                                //导航回调
                                $this.bus.$emit('naving',point);

                            }

                            else{

                                //虚拟定位点
                                if($brtmap.$mapStep.type !='toNAVING' &&
                                    $currentFloor.floorNumber != point.floor){
                                    $brtmap.$marker.virtualLocation.setLnglat(point,$currentFloor.floorNumber);

                                }else{
                                    $brtmap.$marker.virtualLocation.empty();
                                }

                                if($locateLazy){

                                    /***新增当前点惰性处理 以及漫游吸附在路网上****/

                                    let _d = 0,
                                        markPoint,
                                        routePoint,
                                        _point2 = point,
                                        _point1 = $brtmap.$locate.point,
                                        isHide = $brtmap.$marker.location.marker._lnglat[0] === 0 &&  $brtmap.$marker.location.marker._lnglat[1] === 0;

                                    if(_point1 && _point2){
                                        _d = Math.sqrt((_point1.x - _point2.x) * (_point1.x - _point2.x) + (_point1.y - _point2.y) * (_point1.y - _point2.y));
                                    }

                                    //防止隐藏问题
                                    if(isHide){$brtmap.$marker.location.setLnglat(point,point.floor,$locateTransit);}

                                    if(_d>=0.1 || isHide){


                                        markPoint = point;

                                        //吸附路网点位
                                        if($locateIsRoutePoint){
                                            routePoint = $VAR.map.adsorbentAnalyze(point);
                                            markPoint = routePoint;
                                        }

                                        //定位惯性
                                        if($locateInertance){
                                            if(!$brtmapLocate.inertance) $brtmapLocate.inertance = true;
                                        }

                                        $brtmap.$marker.location.setLnglat(markPoint,markPoint.floor,$locateTransit); //第三个参数为过渡动画

                                    }

                                    /***新增当前点惰性处理 以及漫游吸附在路网上****/

                                }

                                else{

                                    let markPoint,
                                        routePoint;

                                    markPoint = point;

                                    //吸附路网点位
                                    if($locateIsRoutePoint){
                                        routePoint = $VAR.map.adsorbentAnalyze(point);
                                        markPoint = routePoint;
                                    }

                                    //定位惯性
                                    if($locateInertance){
                                        if(!$brtmapLocate.inertance) $brtmapLocate.inertance = true;
                                    }


                                    $brtmap.$marker.location.setLnglat(markPoint,markPoint.floor,$locateTransit); //第三个参数为过渡动画
                                }


                            }
                        }



                        /********存储定位**********/

                        $brtmap.$locate.point = Object.assign({},$locatePoint,point);

                        /********存储定位**********/





                        /******定位点参与规划********/

                        let $route = $brtmap.$route,
                            $selecte = $brtmap.$selecte;
                        //防止重复规划
                        if($this.$mapStep.type != 'planRoute' && $route.selectType.type == 'location'){$route.selectType.type = '';}

                        if($this.selectPoint){

                            $this.selectPoint = false;

                            if($this.$mapStep.type == 'planRoute'){

                                if($selecte.startPoint && !$selecte.endPoint){

                                    $this.bus.$emit('startAndEnd', {type: 1})

                                }else{

                                    $this.bus.$emit('startAndEnd', {type: 2})

                                }

                            }
                        }

                        /******定位点参与规划********/

                    }

                })

                //监听罗盘角度
                $brtmapLocate.on('compass',angle=>{

                    if(JSON.stringify($locatePoint) != '{}'){

                        //记录角度
                        $locatePoint.angle = angle;

                        if($this.$mapStep.type != 'toNAVING'){

                            if($brtmap.$marker.location){
                                $brtmap.$marker.location.setAngle(angle);
                            }

                            if($brtmap.$marker.virtualLocation){
                                $brtmap.$marker.virtualLocation.setAngle(angle);
                            }

                            //定位跟随模式
                            if($brtmap.$marker.location.isFirst){
                                //stop停止上次动画 (注：duration默认500s 扫描有我们自己定,最好相等)
                                $VAR.map.stop().easeTo({
                                    bearing:angle,
                                    center:[$locatePoint.lng,$locatePoint.lat],
                                    duration:200
                                })
                            }

                        }else{
                            //指针跟随转动
                            if(!$VAR.$nav.markerFollowRouteAngle){
                                $brtmap.$marker.navLocation.setAngle(angle);
                            }
                        }
                    }
                })


                //监听信号值
                let $rssi,
                    $rssiTime,
                    $rssiChange;

                $brtmapLocate.on('rssi',rssi=>{


                    if(JSON.stringify($locatePoint) != '{}'){

                        //跟随视角不处理信号
                        if(
                            $this.moduleState != 8 &&
                            $this.moduleState != 9
                        ){

                            if( rssi < 2){

                                if($rssiChange)return;

                                $rssiChange = true;

                                $rssi = rssi;

                                if($rssiTime){
                                    clearTimeout($rssiTime);
                                    $rssiTime = '';
                                }

                                //3s再次确认是否为弱信号
                                $rssiTime = setTimeout(()=>{

                                        if($rssi === rssi){

                                            $locatePoint.rssi = $rssi;

                                            if($this.$mapStep.type == 'toNAVING' || $this.$mapStep.type == 'planRoute' || $rssi === 1){
                                                $locatePoint.rssi = 1;
                                                $this.moduleState = 11;
                                            }else{
                                                $locatePoint.rssi = 0;
                                                $this.moduleState = 7;
                                            }

                                        }

                                        $rssiChange = false;
                                },3000);

                            }else{

                                if($rssiTime){
                                    clearTimeout($rssiTime);
                                    $rssiTime = '';
                                    $rssiChange = false;
                                }

                                $this.moduleState = 3;
                                $locatePoint.rssi = 2;

                            }
                        }
                    }
                })
            },

            success(){

                this.$BRT.$options.viewChange = true;
                this.bus.$emit('locationView',true);
            },

            viewChange(){

                this.bus.$emit('locationView',false);

            },

            openLocation(){

                //规划路径
                if(this.$mapStep.type == 'planRoute'){

                    this.$BRT.$route.selectType.type = 'location';

                }else{

                    this.moduleState = 12;

                }

            }
        },

        components:{
            Button
        },

        watch:{

            moduleState(v1,v2){

                let $this = this,
                    $brtmap =$this.$store.state.mapStore.brtmap,
                    $hideTxt=0,
                    $hideTimer;

                //隐藏对应提示
                $hideTxt = v1 <= 3 ?( v1 == 1 ? 1 : 3):( v1<=7 ? 7:( v1<=9 ? 9:( v1<=11 ? 11:v1)));


                $hideTimer?clearTimeout($hideTimer):'';

                $hideTimer = setTimeout(function () {
                    //无提示状态(状态1比较特殊)
                    if(v1 == $this.moduleState){ v1 == 1 ? $this.moduleState=0 : $this.moduleState = $hideTxt;}
                    else {clearTimeout($hideTimer)}

                },3000)

                //加载
                if(v1 == 12){

                    //初次获取签名并开启设备监听
                    // if($brtmap.$locate.init){
                    //
                    //     $this.get_wx_sign();
                    //
                    // }else{
                    //     //开启扫描
                    //     $this.startLocate();
                    // }

                    //开启扫描
                    let callback = ()=>{
                        $this.startLocate();
                        if($brtmap.$locate.init){
                            $this.onSearchBeacons();
                        }
                    };

                    if(!$this.$mapEventManger.mapWxReadyStatus){
                        $this.$mapEventManger.mapWxReadyEvents.push(callback)
                    }else{
                        callback && callback();
                    }

                    $this.locateTime = 10;
                    $this.loading = true;//开启计时

                    //路径规划自动填充$this.$mapStep.type == 'playRoute' &&
                    $this.$BRT.$route.selectType.type == 'location' ? this.selectPoint=true : ''

                    $loadingTime ? clearInterval($loadingTime) : '';

                    $this.time = '';

                    let $loadingTime = setInterval(function () {

                        if( !$this.loading || $this.locateTime <=0){

                            //没定位到 (失败版块不用改变状态)
                            if(!($this.moduleState >= 4 && $this.moduleState <= 7) && $this.locateTime <=0){

                                if($this.locateTime <= 0){    //清除显示

                                    $brtmap.$marker.location.empty();
                                    // $brtmap.$marker.navLocation.empty();

                                    if($this.selectPoint){//路径规划失败

                                        //防止其他操作被干扰
                                        if($this.$mapStep.type != 'planRoute'){

                                            $this.selectPoint = false;
                                            $this.$BRT.$route.selectType.type = '';

                                        }else{

                                            $this.$message.info('路径规划失败');
                                            //再次规划标点
                                            $this.$BRT.$route.selectType.type = '';
                                            $this.bus.$emit('startAndEnd',{type:0})

                                        }

                                    }

                                    if($this.searchAgain){
                                        $this.moduleState=6;
                                    }else{
                                        $this.moduleState = 5;
                                    }

                                }else{
                                    $this.moduleState=6
                                }

                                //if($this.$mapStep.type == 'toNAVING' && $this.$BRT.$NAVTO.NAVType && $this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE'){   //模拟导航视角

                                //跟随视角
                                if($this.$BRT.$marker.navLocation.isFirst){$this.moduleState = 9;}

                                else if(!$this.$BRT.$marker.navLocation.isFirst){

                                    if($this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE'){ //模拟导航
                                        this.moduleState = 3;
                                    }else if($this.$BRT.$NAVTO.NAVType == 'NAVINDICATE'){   //步行导航
                                        this.moduleState = 7;
                                    }

                                }

                            }

                            else{

                                if($this.moduleState >= 4 && $this.moduleState <= 7 && $this.selectPoint){

                                    $this.$message.info('路径规划失败');

                                    //再次规划标点
                                    $this.$BRT.$route.selectType.type = '';
                                    $this.bus.$emit('startAndEnd',{type:0});

                                }

                            }


                            if($this.$BRT.$urlParam.filter.status){$this.bus.$emit('getFilter_bus',{status:1})}

                            else if($this.$BRT.$urlParam.nearLift.status){    //失败

                                $this.bus.$emit('getNearLift',{status:1});

                            }else if($this.$BRT.$urlParam.planRoute.status){//规划路径获取起点

                                if($this.$BRT.$urlParam.planRoute.endPoi){
                                    $this.bus.$emit('getPlanRoute_start',{status:1});
                                }

                            }




                            $brtmap.$locate.init = false;//防止再次获取微信签名

                            clearInterval($loadingTime);
                            return;
                        }

                        $this.locateTime--;

                    },1000)
                }

            },

            selectType(v1,v2){
                v1 == 'location' ? (this.moduleState = 12,this.selectPoint=true) : '';

            },

            mapStep(v1,v2){
                //防止加载
                if(v1 == 'toNAVING' && this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE'){this.loading = false;this.moduleState = 9;}

            },

        },

        computed:{

            selectType(){
                return this.$BRT.$route.selectType.type
            },

            mapStep(){
                return this.$mapStep.type
            },

        },

        mounted(){

            // 状态切换test
            let $this =this,$brtmap =$this.$store.state.mapStore.brtmap;

            //初次开启扫描
            if($brtmap.$locate.init){$this.moduleState = 12;}
        }

    }
</script>

<style lang="less">
    @import "LocateModule.less";
</style>
